import DefaultLayout from "../../components/layout/DefaultLayout";
import FormBlocContainer from "../../components/layout/form/FormBlocContainer";
import { useParams, useHistory } from "react-router-dom"; // Import useNavigate
import React from "react";
import { Button, Grid, Typography } from "@mui/material";
import { useDispatch } from "react-redux";
import { toggleLoading } from "../../store/slices/loadingSlice";
import InsuredRegistrationService from "../../api/extranet/services/InsuredRegistrationService";
import useMessageNotifier from "../../helpers/hooks/component/useMessageNotifier";
import SweetAlert from "sweetalert2";
import theme from "../../layouts/MuiTheme";
import SubCard from "../../components/berry/ui-component/cards/SubCard";

const InvalidAccountPage = () => { // Removed history prop
    const { activationToken } = useParams();
    const dispatch = useDispatch();
    const { showMessage } = useMessageNotifier();
    const history = useHistory(); // Create navigate function
    const forgotPasswordUrl = `${process.env.REACT_APP_KEYCLOAK_URL}/realms/${process.env.REACT_APP_KEYCLOAK_REALM}/login-actions/reset-credentials?client_id=${process.env.REACT_APP_KEYCLOAK_CLIENT_ID}`;

    const callResendActivationMail = async () => {
        dispatch(toggleLoading());
        const resultResend = await InsuredRegistrationService.resendActivationMail(activationToken);
        dispatch(toggleLoading());
        return resultResend;
    }

    const handleClick = async () => {
        const resultResend = await callResendActivationMail();
        if (resultResend.code === 200) {
            SweetAlert.fire({
                title: `<i class="fas fa-exclamation-circle"></i> Bravo`,
                html: `<p>${resultResend.message}</p>`,
                reverseButtons: false,
                showCancelButton: false,
                showConfirmButton: true,
                confirmButtonColor: '#EF595D',
                confirmButtonText: 'Oui',
                allowOutsideClick: false,
            }).then((confirm) => {
                if (confirm.value) {
                    history.push('ui/inform-verify-email', { state: { email: resultResend.email, linkDuration: resultResend.linkExpirationTime } }); // Use navigate instead of pathManager.goTo
                }
            })
        } else {
            showMessage(resultResend.message, 'error');
        }
    }

    const handleResetPassword = () => {
        window.location.href = forgotPasswordUrl;
    }

    return (
        <DefaultLayout>
            <FormBlocContainer>
                <Grid container>
                    <Grid item xs={0} sm={2}></Grid>
                    <Grid item xs={12} sm={8}>
                        <SubCard>
                            <Grid item xs={12}>
                                <Typography variant="h2" sx={{ fontWeight: 'bold' }}>
                                    Lien inactif
                                </Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <p>
                                    Votre lien a expiré après 7 heures, votre lien n’est plus valable
                                    <br />
                                    <br />
                                    Cliquez sur le bouton ci-dessous pour recevoir un nouveau lien d’activation :
                                    <br />
                                    <br />
                                    <Button variant="contained" color="primary" onClick={handleClick}>
                                        Je renvoie un lien d’activation
                                    </Button>
                                    <br/>
                                    <br/>
                                    ⚠️ Si vous ne recevez pas le lien, votre adresse email est peut-être déjà activée.
                                    Dans ce cas, vous pouvez réinitialiser votre mot de passe ici :
                                    <br/>
                                    <br/>
                                    <Button variant="contained" color="primary" onClick={handleResetPassword}>
                                        J’ai perdu mes accès
                                    </Button>
                                </p>
                            </Grid>
                        </SubCard>
                    </Grid>
                </Grid>
            </FormBlocContainer>
        </DefaultLayout>
    )
}

export default InvalidAccountPage;
